import type { FaireProductEntity } from "../../entity_types/product";

export const p_hn9hxrjcm9: FaireProductEntity = {
  token: "p_hn9hxrjcm9",
  type: "product",
  name: "Bohemian Breakfast Black Tea- Probiotic Rich Vanilla Puerh",
  brandToken: "b_14yjrsol9b",
  brandName: "Magic Hour",
  imageUrl:
    "https://cdn.faire.com/fastly/eda50eaf246347ba5c25b3e6ecefbf0e051014e88ccb8bd37de642bc85f8a4fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69532fab781b3f4d694279d831899d94f50d38a10cac825f711131711e14c44b.jpeg",
    "https://cdn.faire.com/fastly/05d172fe6b080e6d5e822935e7a8724fbad23bb72220e7f058be443504a00e6c.jpeg",
    "https://cdn.faire.com/fastly/c5d6c0e26b4758ffe221540659ae4c5177f32c18919e4da9ed9afad1eccc7d73.jpeg",
    "https://cdn.faire.com/fastly/8f70129cc842f2a95f9d211091d69431a03946cec8b8b9d20dfa11882701329c.jpeg",
    "https://cdn.faire.com/fastly/97e2026de2e829a0be9f9b7a8ed1a76b5e2ef492b0e7ee3533c6f5c0c1bf7abf.jpeg",
    "https://cdn.faire.com/fastly/17b5acf13acd92e553b829660597708900dbe0a7b9feeff3d0dd066f4e6f392a.jpeg",
  ],
  priceDollars: 26,
  description:
    "Our bestselling coffee alternative for digestion, clarity & positive mood!\n\nTasting Notes: Round, bold & rich with hints of chocolate & vanilla. Perfectly balanced blend of Puerh probiotic-rich black tea blended with bright Biodynamic Sri Lankan tea then sprinkled with sunshine from Rwandan black teas. Bourbon vanilla & pomegranate extract create a subtle & harmonious healthy and deeply satisfying alternative to your morning coffee.\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\nOrganic Fair Trade Puerh Black Tea, Biodynamic Sri Lankan Black Tea, Organic Rwandan Black Tea, Organic Black Currant Fruit, Natural Pomegranate extract, Bourbon Vanilla Extract",
  tags: [],
  msrpDollars: 47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:42.778Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
